var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"df-section df-section-attachments"},[_c('div',{staticClass:"df-font-semibold"},[_vm._v(_vm._s(_vm.$t("df-section-attachments.title")))]),_c('div',{staticClass:"df-space-y-2"},_vm._l((_vm.files),function(file){return _c('df-card-attachment',{key:file.uniqueId,attrs:{"attachment":file}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }